import * as React from 'react';

import {FileUploadInput as ShellFileUploadInput} from '../../../client_modules/shells/react/components/file-upload-input/file-upload-input';

import {useFileUpload} from './use-file-upload';

const DEFAULT_UPLOAD_URL = '/file/upload-file';

type Props = {
    accepts: string[];
    getRef: (ref?: HTMLInputElement | null | undefined) => void;
    uploadUrl?: string;
    onUploadSuccess: () => void;
    allowMultiple?: boolean;
};

export function FileUploadInputWrapper(props: Props) {
    const {accepts, getRef, uploadUrl, onUploadSuccess, allowMultiple = false} = props;

    const {uploadFile, error, clearError} = useFileUpload(uploadUrl || DEFAULT_UPLOAD_URL);

    React.useEffect(() => {
        return () => {
            if (error) {
                clearError();
            }
        };
    }, [error, clearError]);

    const handleUpload = React.useCallback(
        (files: File[]) => {
            clearError();

            (async () => {
                for (const file of files) {
                    try {
                        const result = await uploadFile(file, onUploadSuccess);
                        if (!result.success) {
                            break;
                        }
                    } catch (_uploadError: any) {
                        break;
                    }
                }
            })();
        },
        [uploadFile, onUploadSuccess, clearError]
    );

    return (
        <ShellFileUploadInput
            onUpload={handleUpload}
            accepts={accepts}
            getRef={getRef}
            allowMultiple={allowMultiple}
        />
    );
}
